import { useContext } from "react";

import { useMedplumProfile } from "@medplum/react";

import { Avatar, Flex, Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import { NavbarContext } from "@/contexts/navbar";
import { getDisplayName, getProfilePicture } from "@/utils/person";

import NavBarBurger from "./NavBarBurger";

export default function MobileHeader() {
  const { collapsed } = useContext(NavbarContext);
  const profile = useMedplumProfile();

  return (
    <Flex p="md" w="100%" align="center" hiddenFrom="sm" justify="space-between">
      <Group>
        <Avatar size="md" radius="xl" variant="light" src={getProfilePicture(profile)} />
        <TextWrapper>{getDisplayName(profile)}</TextWrapper>
      </Group>
      {!collapsed && <NavBarBurger />}
    </Flex>
  );
}
